var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v800l700-400z","fill":"currentColor","fillRule":"nonzero"}));
}

Play.defaultProps = {"width":"700","height":"800","viewBox":"0 0 700 800"};

module.exports = Play;

Play.default = Play;
